import { apiClient } from '../lib/api.js';

class AuthService {
  async getAgents() {
    try {
      return await apiClient.get('/agents');
    } catch (error) {
      throw error;
    }
  }

  async getAgentById(id) {
    try {
      return await apiClient.get(`/agents/${id}`);
    } catch (error) {
      throw error;
    }
  }

  async getProperties() {
    try {
      return await apiClient.get('/properties');
    } catch (error) {
      throw error;
    }
  }

  async getPropertyById(id) {
    try {
      return await apiClient.get(`/properties/${id}`);
    } catch (error) {
      throw error;
    }
  }

  async getArticles() {
    try {
      return await apiClient.get('/articles');
    } catch (error) {
      throw error;
    }
  }

  async getArticlesById(id) {
    try {
      return await apiClient.get(`/articles/${id}`);
    } catch (error) {
      throw error;
    }
  }
}

export const authService = new AuthService();
